export default "__VITE_ASSET__CG6VHrzg__ 1034w, __VITE_ASSET__1u4_98O4__ 767w, __VITE_ASSET__Bg7wmAMV__ 500w";